import React from 'react';
import ReactDOM from 'react-dom';
import localforage from 'localforage';
import { createStore } from 'polotno/model/store';
import { unstable_setRemoveBackgroundEnabled } from 'polotno/config';

import MaTranslations from './ma-components/ma-translations';
import './index.css';
import './ma-styles/styles.css';
import App from './App';

unstable_setRemoveBackgroundEnabled(true);


const store = createStore({ key: 'nFA5H9elEytDyPyvKL7T' });

window.fileName = ''; //variavel global nome do documento
window.store = store;

localforage.getItem('polotno-state', function (err, json) {
  if (json) {
    store.loadJSON(json);
  }
  if (!store.pages.length) {
    store.addPage();
    store.setSize(1920, 1080);
  }
});

store.on('change', () => {
  try {
    const json = store.toJSON();
    localforage.setItem('polotno-state', json);
  } catch (e) { }
});

ReactDOM.render(
  <React.StrictMode>
    <App store={store} />
  </React.StrictMode>,
  document.getElementById('root')
);
